import React, { Component } from 'react';
import { Route, Switch } from 'react-router';
import * as ROUTES from 'config/routes';
import { PageContainer } from '@/smart-components';
import { PageContent } from 'components';
import { userIsAuthenticatedRedir } from 'hocs/auth';
import EvacuationDemoDashboard from './evacuation-demo-dashboard';
import EvacuationRollCall from './evacuation-roll-call';
import './index.scss';

class EvacuationContainer extends Component {
	constructor(props) {
		super(props);
	}
	render() {
		return (
			<PageContainer>
				<PageContent className="evacuation-demo-content">
					{/*<PageContent.Sidebar>*/}
					{/*<LinkedSideNavigation menus={menus} />*/}
					{/*</PageContent.Sidebar>*/}
					<PageContent.Main>
						<Switch>
							<Route
								exact
								path={ROUTES.EVACUATION_DEMO}
								component={EvacuationDemoDashboard}
							/>
							<Route
								exact
								path={ROUTES.EVACUATION_ROLL_CALL}
								component={EvacuationRollCall}
							/>
						</Switch>
					</PageContent.Main>
				</PageContent>
			</PageContainer>
		);
	}
}

export default userIsAuthenticatedRedir(EvacuationContainer);



// WEBPACK FOOTER //
// ./src/pages/evacuation-demo/index.js